// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {AttrsSchema, Component, jsx} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {SelectEl} from 'common/components/select';
import {SelectTheme} from 'common/components/select/constants';
import {InputEl} from 'common/components/input';
import {IronContextRegistry} from 'common/report/context-registry';
import {parseNumber} from 'common/util';

import css from './index.inline.styl';

type FlowsCardinalityControlAttrs = {
  cardinality: number;
};

export interface FlowsCardinalityControlJsxProps {
  attrs: FlowsCardinalityControlAttrs;
  on: {
    change: (ev: CustomEvent<number>) => void;
  };
}

export class FlowsCardinalityControl extends Component<
  EmptyObj,
  FlowsCardinalityControlAttrs,
  unknown,
  unknown,
  IronContextRegistry
> {
  static get attrsSchema(): AttrsSchema<FlowsCardinalityControlAttrs> {
    return {
      ...super.attrsSchema,
      cardinality: `number`,
    };
  }

  get config() {
    return {
      css,
      useShadowDom: true,
      contexts: [`i18n` as const],
      template: () => {
        const t = this.getContext(`i18n`).t;
        return (
          <SelectEl
            sel='.cardinality-control'
            attrs={{
              theme: SelectTheme.Secondary,
              'selected-option': t(`flows.cardinality.rows-label`, {count: this.attr(`cardinality`)}),
              'never-show-caret': true,
            }}
          >
            <div sel='.cardinality-control-container' attrs={{slot: `body`}}>
              <h4>{t(`flows.cardinality.rows-title`)}</h4>
              <h5>{t(`flows.cardinality.rows-description`)}</h5>
              <div sel='.option-container'>
                <InputEl
                  attrs={{type: `number`, size: `medium`}}
                  props={{value: this.attr(`cardinality`).toString()}}
                  on={{
                    change: (ev) => {
                      const value = parseNumber(ev.detail.value);
                      if (value !== null && value >= 1) {
                        this.dispatchEvent(new CustomEvent(`change`, {detail: parseNumber(ev.detail.value)}));
                      }
                    },
                  }}
                />
                {String(t(`flows.cardinality.rows-title`)).toLowerCase()}
              </div>
            </div>
          </SelectEl>
        );
      },
    };
  }
}

export const FlowsCardinalityControlEl = defineAndMakeJsxFactory<FlowsCardinalityControlJsxProps>(
  `flows-cardinality-control`,
  FlowsCardinalityControl,
);
export const FlowsCardinalityControlReact = panel2react<FlowsCardinalityControlJsxProps>(
  `flows-cardinality-control`,
  FlowsCardinalityControl,
);
